import requstHelper from './requstHelper';
import store from '../store';

class reportApi {
  // 默认构造函数
  constructor() {
    return this;
  }

  // 上报按钮点击
  static baoSaveReport = (params) => {
    const myParams = params;
    const encrypt = store.getters['user/encrypt']; // 获取encrypt
    const userInfo = store.getters['user/userInfo']; // 获取用户信息
    if (!(encrypt)) { return false; } // 判断用户是否登录
    myParams.userId = userInfo.userId;
    myParams.areaCode = process.env.AREA_CODE;
    myParams.companyCode = process.env.COMPANY_CODE; // 公司号
    myParams.DeviceTime = new Date();
    myParams.Browser = '';
    myParams.Access = '';
    myParams.DeviceID = '';
    myParams.PageID = '';
    myParams.ActionType = '1';
    myParams.ClientIP = '';
    myParams.Browser = location.href;
    myParams.ActionObj = '';
    myParams.AppVersion = navigator.appVersion;
    myParams.MobileModel = navigator.appVersion;
    myParams.MobileSystemModel = navigator.appVersion;
    return requstHelper.fetch('common/report/page/save',myParams,
      {
        header: {
          encrypt: encrypt,
        },
      },
    );
  };

  // 获取积分上报
  static upReported = (params) => {
    const myParams = params;
    const encrypt = store.getters['user/encrypt']; // 获取encrypt
    const userInfo = store.getters['user/userInfo']; // 获取用户信息
    myParams.companyCode = process.env.COMPANY_CODE;
    myParams.areaCode = process.env.AREA_CODE;
    if (!(encrypt)) { return false; } // 判断用户是否登录
    myParams.userId = userInfo.userId;
    return requstHelper.fetch('common/up/reported', myParams, {
      header: {
        encrypt: encrypt,
      },
      method: 'POST',
    });
  };

  // 上报用户访问时长
  static reportUserTime = (params) => {
    const myParams = params;
    const encrypt = store.getters['user/encrypt']; // 获取encrypt
    const userInfo = store.getters['user/userInfo']; // 获取用户信息
    myParams.companyCode = process.env.COMPANY_CODE;
    myParams.areaCode = process.env.AREA_CODE;
    if (!(encrypt)) { return false; } // 判断用户是否登录
    myParams.userId = userInfo.userId;
    return requstHelper.fetch('common/report/time/save', myParams, {
      header: {
        encrypt: encrypt
      },
    });
  };

  // 转换key值，部分接口不支持json
  static stringify = (param) => {
    const query = [];
    Object.keys(param).forEach((key) => {
      query.push(`${key}=${param[key]}`);
    });
    return query.join('&');
  }
}

export default reportApi;


// WEBPACK FOOTER //
// ./src/api/reportAPI.js